import { ServiceResponse } from "../../api/ServiceResponse";
import { FuelDto } from "./fuelDto";

export class FuelResponse extends ServiceResponse {
  fuelList?: FuelDto[];
  count?: number;

  constructor(init?: Partial<FuelResponse>) {
    super(init); // call parent constructor
    Object.assign(this, init);
  }

  // Getters & Setters
  getFuelList(): FuelDto[] | undefined {
    return this.fuelList;
  }
  setFuelList(value: FuelDto[] | undefined): void {
    this.fuelList = value;
  }

  getCount(): number | undefined {
    return this.count;
  }
  setCount(value: number | undefined): void {
    this.count = value;
  }
}
